import { FC, ReactNode } from "react";
import { styled } from "@mui/material";

interface Props {
  children?: ReactNode;
  minHeight: number | string;
}

const ContainerScrollable: FC<Props> = ({ children, minHeight }) => {
  return <Container minHeight={minHeight}>{children}</Container>;
};

export default ContainerScrollable;

const Container = styled("div")<Props>`
  max-height: ${(props) => props?.minHeight || "690px"};
  overflow-y: auto;
  overflow-x: clip;

  /* width */
  ::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #bebebe;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #bebebe;
  }
`;
